import React from "react";
import { motion } from "framer-motion";
import { Headphones, HeartPulse, Footprints } from "lucide-react";

const STEPS = [
  {
    label: "Écoute",
    headline: "Tu écoutes.",
    detail:
      "Casque, lumière douce, dix minutes pour toi. Tu laisses la voix descendre, sans rien forcer.",
    icon: Headphones,
  },
  {
    label: "Ressens",
    headline: "Tu laisses descendre.",
    detail:
      "Quelque chose se replace à l'intérieur. Plus calme. Plus large. Plus à toi.",
    icon: HeartPulse,
  },
  {
    label: "Ancre",
    headline: "Tu poses un geste.",
    detail:
      "Un petit acte concret dans les 24h. Pas spectaculaire. Juste un oui que tu te donnes.",
    icon: Footprints,
  },
];

export default function HowItWorks() {
  return (
    <section
      data-testid="how-it-works-section"
      id="protocole"
      className="relative py-24 md:py-36 px-6 md:px-10 bg-obsidian-surface/40"
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-16 md:mb-24">
          <p className="text-xs tracking-[0.35em] uppercase text-gold mb-6">
            04 · Protocole
          </p>
          <h2 className="font-display uppercase text-5xl md:text-7xl lg:text-8xl leading-[0.9] tracking-[-0.03em]">
            Écoute. Ressens.{" "}
            <span className="font-serif italic font-light text-gold normal-case lowercase">
              ancre.
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-px bg-white/5 rounded-3xl overflow-hidden border border-white/[0.06]">
          {STEPS.map((step, i) => (
            <motion.div
              key={step.label}
              data-testid={`step-${i + 1}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{
                duration: 0.8,
                delay: i * 0.15,
                ease: [0.16, 1, 0.3, 1],
              }}
              className="relative bg-obsidian p-10 md:p-12 group"
            >
              <div className="flex items-center justify-between mb-12">
                <span className="font-display text-5xl text-gold/30">
                  0{i + 1}
                </span>
                <step.icon className="w-6 h-6 text-gold opacity-80" />
              </div>

              <p className="text-xs tracking-[0.3em] uppercase text-gold mb-4">
                {step.label}
              </p>
              <h3 className="font-display text-3xl md:text-4xl text-ink-50 mb-6 tracking-tight">
                {step.headline}
              </h3>
              <p className="font-serif italic text-ink-400 text-lg leading-relaxed lowercase">
                {step.detail}
              </p>

              {i < STEPS.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-3 z-10 text-gold/60 text-xl">
                  →
                </div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
